<template>
  <div class="header-alerts">
    <div
      v-for="(alarmList, index) in computedAlarmList"
      :key="index"
    >
      <h6
        class="header-alerts__title"
        :title="$t(`messages.sharedTexts.alarms.${alarmList.type}Alarms`)"
      >
        {{ $t(`messages.sharedTexts.status.${alarmList.type}`) }}
      </h6>
      <ol>
        <li
          v-for="alarm in alarmList.list"
          :key="alarm.id"
          class="header-alerts__alarm"
          :class="[alarmList.type, 'header-alerts__alarm--'+alarm.urgency]"
          @click.stop="alarmClicked(alarm)"
        >
          <div>
            <font-awesome-icon
              :icon="['fas', 'bell']"
              class="header-alerts__alarm__icon"
            />
            <h4 class="header-alerts__alarm__text">
              {{ alarm.label }}
            </h4>
            <div class="header-alerts__alarm__time">
              <font-awesome-icon
                :icon="['far', 'clock']"
                class="header-alerts__alarm__time__icon"
              />
              <span>
                {{ alarm.activeDT }}
              </span>
              <span class="header-alerts__alarm__time__active">
                <slot v-if="alarm.passiveDT">
                  <span v-if="alarm.active !== alarm.passive">
                    alarm.passiveDT
                  </span>
                  <strong v-else>{{ $t('messages.sharedTexts.alarms.instantAlarm') }}</strong>
                </slot>
                <strong v-else>
                  {{ $t('messages.sharedTexts.alarms.currentlyActive') }}
                </strong>
              </span>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'HeaderAlerts',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon
  },
  props:
  {
    alarms:
    {
      type: Object,
      default() {
        return {
          list: [{
            label: 'Moisture outside limits',
            urgency: 3,
            active: 1547568000000,
            passive: 'Jan 14th 2019',
            activeDT: 'Jan 15th 2019',
            passiveDT: null,
            state: 'red',
            handler: 'service-moist-alarm',
            seen: false,
            fixed: false
          }],
          count: 1,
          maximumUrgency: 3,
          maximumActiveUrgency: 3,
          maximumUrgencyState: 'red',
          maximumActiveUrgencyState: 'red'
        }
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedAlarmList() {
      let rtn = []

      if(this.computedActiveAlarms && this.computedActiveAlarms.length) {
        rtn.push({
          type: 'active',
          list: this.computedActiveAlarms
        })
      }
      if(this.computedPassiveAlarms && this.computedPassiveAlarms.length) {
        rtn.push({
          type: 'passive',
          list: this.computedPassiveAlarms
        })
      }
      if(this.computedSeenAlarms && this.computedSeenAlarms.length) {
        rtn.push({
          type: 'seen',
          list: this.computedSeenAlarms
        })
      }

      return rtn
    },
    computedActiveAlarms() {
      if(this.alarms && this.alarms.list) {
        return this.alarms.list.filter(alarm => (isNaN(alarm.passive)  || alarm.active === alarm.passive) && !alarm.seen).sort(this.sortAlarms)
      }
      return null
    },
    computedPassiveAlarms() {
      if(this.alarms && this.alarms.list) {
        return this.alarms.list.filter(alarm => !isNaN(alarm.passive) && alarm.active !== alarm.passive && !alarm.seen).sort(this.sortAlarms)
      }
      return null
    },
    computedSeenAlarms() {
      if(this.alarms && this.alarms.list) {
        return this.alarms.list.filter(alarm => alarm.seen).sort(this.sortAlarms)
      }
      return null
    }
  },
  methods: {
    alarmClicked(alarm) {
      this.$parent.$emit('setPageMessageParent', {
        target: 'ShowModal',
        modalData: {
          data: alarm,
          component: 'AlarmHandler'
        }
      })
    },
    sortAlarms(a,b) {
      return b.urgency - a.urgency
    }
  }
}
</script>

<style lang="scss">
.header-alerts {
  padding: 2px;
  margin-top: 20px;

  &__title {
    color: lighten($color-grey-darker, 5);
    margin: 15px 0 0;
    cursor: help;
  }

  &__alarm {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $color-white;
    background-repeat: no-repeat;
    padding: $application-base-padding;
    padding-left: 55px;
    background-position: left center;
    border-radius: $application-base-border-radius;
    margin-top: $application-base-padding;
    cursor: pointer;

    > * {
      flex: 0 1 auto;
    }

    &__text {
      margin: 0 0 7px;
      font-size: 15px;
      font-weight: $font-primary-semibold;
    }

    &__time {
      font-size: 14px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &__active {
        &::before {
          content: '-';
          padding: 0 5px;
        }
      }

      > * {
        white-space: nowrap;
        display: block;
        flex: 0 1 auto;
      }

      &__icon {
        margin-right: 5px;
      }
    }

    .g-btn {
      padding: 5px 10px;
    }

    &__icon {
      position: absolute;
      left: 15px;
      font-size: 30px;
    }

    &--1 { // info
      border: $application-base-border-width solid $color-green-ok;
      &.active {
        box-shadow: 0 0 6px $color-green-ok, 0 0 6px $color-green-ok inset;
      }

      .header-alerts__alarm__icon {
        color: $color-green-ok;
      }

    }
    &--2 { // warning
      border: $application-base-border-width solid $color-yellow-warn;
      &.active {
        box-shadow: 0 0 6px $color-yellow-warn, 0 0 6px $color-yellow-warn inset;
      }

      .header-alerts__alarm__icon {
        color: $color-yellow-warn;
      }
    }
    &--3 { // error
      border: $application-base-border-width solid $color-red-error;
      &.active {
        box-shadow: 0 0 2px $color-red-error, 0 0 2px $color-red-error inset;
      }

      .header-alerts__alarm__icon {
        color: $color-red-error
      }
    }

    &.seen {
      opacity: 0.45;
    }
  }
}
</style>
